module.exports = __webpack_public_path__ + "media/images/landing/crime/financial-aa82d1d82bb03ad9561dbe0d9bcacd8c.png";